import { render, staticRenderFns } from "./modelWatchInfo.vue?vue&type=template&id=56b7c52f&scoped=true&"
import script from "./modelWatchInfo.vue?vue&type=script&lang=js&"
export * from "./modelWatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./modelWatchInfo.vue?vue&type=style&index=0&id=56b7c52f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7c52f",
  null
  
)

export default component.exports